// Frontend authentication hook for credentials auth
// Provides user state, organization context, and platform roles

import { useAuthContext } from "@/contexts/AuthContext";

export function useAuth() {
  const { 
    user, 
    loading, 
    canManageOrganizations, 
    isSuperAdmin, 
    signOut,
    userOrganizations,
    currentOrganization,
    setCurrentOrganization,
    platformRoles,
    currentWorkspace,
    setCurrentWorkspace,
    switchToPersonalWorkspace,
    switchToOrganizationWorkspace,
  } = useAuthContext();

  return {
    user,
    isLoading: loading,
    loading,
    isAuthenticated: !!user,
    canManageOrganizations,
    isSuperAdmin,
    signOut,
    userOrganizations,
    currentOrganization,
    setCurrentOrganization,
    platformRoles,
    currentWorkspace,
    setCurrentWorkspace,
    switchToPersonalWorkspace,
    switchToOrganizationWorkspace,
  };
}
